import $ from 'jquery';

export default () => {
    window.setLoading = (isActive) => {
        var $loadingCnt = $("#ir-loader");
        isActive ? $loadingCnt.removeClass("not-showing") : $loadingCnt.addClass("not-showing");
    }
};


// WEBPACK FOOTER //
// ../views/loading/loading.js